module.exports = __webpack_public_path__ + "static/media/login_img_Gyeonggi1.de07773d.png";